export const overrideWithTranslatedName = (list: any[], languageId: number, deleteTranslations: boolean = false) => {
  return list?.map(x => {
    const translation = x.translations?.find(y => y.languageId === languageId)?.name ?? x.name
    x.name = translation
    if (deleteTranslations) delete x.translations
    return x
  })
}